import * as esbuild from "esbuild-wasm";
import axios from "axios";
import localForage from "localforage";

const fileCache = localForage.createInstance({
    name: 'filecache'
});

(async () => {
    await fileCache.setItem('color', 'red');
})()

export const fetchPlugin = (inputCode: string) => {
    return {
        name: 'fetch-plugin',
        setup(build: esbuild.PluginBuild) {

            build.onLoad({ filter: /(^index\.js$)/}, () => {
                return {
                    loader: 'jsx',
                    contents: inputCode,
                };
            })

            build.onLoad({ filter: /.*/}, async (args: any) => {
                const cachedResult = await fileCache.getItem<esbuild.OnLoadResult>(args.path);
                if (cachedResult){
                    return cachedResult
                }
            })

            build.onLoad({filter: /.css$/}, async (args: any) => {
                const { data, request } = await axios.get(args.path);
                const basePath = new URL('./',request.responseURL).pathname;
                const escapedData  = data.replace(/\n/g, '')
                    .replace(/"/g, '\\"')
                    .replace(/'/g, "\\'");
                const contents = `
                    const style = document.createElement('style');
                    style.innerText = "${escapedData}";
                    document.head.appendChild(style);
                    `;
                const result: esbuild.OnLoadResult = {
                    loader: 'jsx',
                    contents,
                    resolveDir: basePath,
                }
                await fileCache.setItem(args.path, result);
                return result;
            })

            build.onLoad({ filter: /.*/ }, async (args: any) => {
                const { data, request } = await axios.get(args.path);
                const basePath = new URL('./',request.responseURL).pathname;
                const result: esbuild.OnLoadResult = {
                    loader: 'jsx',
                    contents: data,
                    resolveDir: basePath,
                }
                await fileCache.setItem(args.path, result);
                return result;
            });
        }
    }
}